module.exports = __webpack_public_path__ + "img/070B0C_B2C7CE_728FA3_5B748B-256px.9d5e481c.png";